// extracted by mini-css-extract-plugin
module.exports = {"container":"_2hJ5S6q--8AOCBiGVVhH_O","groupsList":"_3yeK_EQOME-5zxG1zni8Ge"};